import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServicioAyudasDxService {

  private HEADERS = new HttpHeaders ({ 'Content-Type' : 'application/json'});

  constructor( private http: HttpClient) { }

  async getAyudasDiagnosticasTTA(codigoBaseDatos: string, tta: number){
    try {
      const url = `${environment.API_REPORTES}/formato-asistencial/ayudas-dx`;
      const body = { codigoBaseDatos, tta, nodo : { } };
      return await this.http.post(url, body, { headers : this.HEADERS});
    }catch (e) {
      console.log('ServicioAyudasDxService.getAyudasDiagnosticasTTA()', e);
    }
  }

  async getFormulacionMedicaTTA(codigoBaseDatos: string, tta: number) {
    try {
      const url = `${environment.API_REPORTES}/formato-asistencial/formulas-medicas`;
      const body: any = { codigoBaseDatos, tta, nodo : { } };
      return await this.http.post(url, body, { headers : this.HEADERS});
    } catch (e){
      console.log('ServicioAyudasDxService.getFormulacionMedicaTTA()', e);
    }
  }

  async getIncapacidadesTTA(codigoBaseDatos: string, tta: number) {
    try {
      const url = `${environment.API_REPORTES}/formato-asistencial/incapacidades`;
      const body: any = { codigoBaseDatos, tta, nodo : { } };
      return await this.http.post(url, body, { headers : this.HEADERS});
    } catch (e) {
      console.error('ServicioAyudasDxService.getIncapacidadesTTA()', e);
    }
  }

}

// Interfaces

export interface AyudaDiagnosticaEntity {
    unco: number;
    cantidad: number;
    indicaciones: string;
    pertinencia: PertinenciaMedicaEntity;
    procedimiento: ProcedimientoEntity;
}

interface ProcedimientoEntity {
  unco: number;
  descripcion: string;
}

interface PertinenciaMedicaEntity{
  unco: number;
  descripcion: string;
}

export interface FormulaMedicaEntity{
  unco: number;
  suministro: SuministroEntity;
  cantidad: number;
  indicaciones: string;
  viaAdministracion: ViaAdministracionEntity;
  dosis: string;
}

interface SuministroEntity {
  unco: number;
  descripcion: string;
}

interface ViaAdministracionEntity {
  unco: number;
  descripcion: string;
}

export interface IncapacidadEntity {
  unco: number;
  copia: boolean;
  prorroga: boolean;
  dias: number;
  fecha: number;
  tipoIncapacidad: string;
  claseAtencion: string;
}